module.exports = __webpack_public_path__ + "img/receive.291c02f3.png";